import React from 'react';
import PropTypes from 'prop-types';
import { getImage } from 'gatsby-plugin-image';
import { Picture } from '@comicrelief/component-library';

import ImagePropType from '../../commonPropTypes/commonPropTypes';
import renderRichText from '../RichText/RichText';
import { Wrapper, ItemWrapper, IFrame } from './IframeBlock.styles';

class IframeBlock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isImageClicked: false,
      iframeHeight: null
    };
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.getIframeSize);
  }

  getIframeSize = (e) => {
    const allowedOrigin = new RegExp('https:\\/\\/[A-Za-z-.]{1,}.comicrelief.com$');
    if (typeof e.data === 'string' && e.origin.match(allowedOrigin)) {
      const json = JSON.parse(e.data);
      if (typeof json.iframe_height !== 'undefined') {
        const iframeHeight = json.iframe_height;
        this.setState((prevState) => {
          let newState;
          if (prevState.iframeHeight !== iframeHeight) {
            newState = {
              iframeHeight
            };
          }
          return newState;
        });
      }
    }
  };

  render() {
    const { data } = this.props;
    const {
      title,
      backgroundColour,
      body,
      iframeLoaded,
      initialHeight,
      embedLink,
      nonProductionEmbedLink,
      placeholderImage,
      placeholderImageAltText
    } = data;

    // Check against specific GATSBY_ENVIRONMENT value set within Concourse for the production build
    const thisURL = nonProductionEmbedLink && process.env.GATSBY_ENVIRONMENT !== 'production'
      ? nonProductionEmbedLink : embedLink;

    const { isImageClicked, iframeHeight } = this.state;

    const thisImageData = getImage(placeholderImage);
    const thisImageLow = thisImageData?.placeholder?.fallback;
    const theseImageSrcSet = thisImageData?.images.sources[0].srcSet;

    return (
      <Wrapper bgColor={backgroundColour}>
        {body && <ItemWrapper>{renderRichText(body, 'inherit', 'iframe')}</ItemWrapper>}
        {iframeLoaded === true || isImageClicked === true || placeholderImage === null ? (
          <IFrame
            title={title}
            width="100%"
            height={iframeHeight === null ? initialHeight : iframeHeight}
            src={thisURL}
            allowFullScreen
            onLoad={() => {
              window.addEventListener('message', this.getIframeSize, false);
            }}
          />
        ) : (
          <ItemWrapper>
            <a
              href={embedLink}
              onClick={(e) => {
                e.preventDefault();
                this.setState({
                  isImageClicked: true
                });
              }}
            >
              <Picture
                alt={placeholderImageAltText}
                imageLow={thisImageLow}
                images={theseImageSrcSet}
                objectFit="cover"
              />
            </a>
          </ItemWrapper>
        )}
      </Wrapper>
    );
  }
}

IframeBlock.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    backgroundColour: PropTypes.string,
    body: PropTypes.shape({
      json: PropTypes.shape({})
    }),
    iframeLoaded: PropTypes.bool,
    initialHeight: PropTypes.number,
    embedLink: PropTypes.string,
    nonProductionEmbedLink: PropTypes.string,
    placeholderImage: ImagePropType,
    placeholderImageAltText: PropTypes.string
  }).isRequired
};

export default IframeBlock;
